// extracted by mini-css-extract-plugin
export default {"decorators":"DecoratedText_decorators__sERXx"};